import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { AppProviders } from '@app/providers';
import { AppRouter } from '@app/router';
import { BRAND } from '@core/brand';

export default function App() {
  // Drive the document title from the brand config (one place to rebrand).
  useEffect(() => {
    document.title = `${BRAND.name} — Admin`;
  }, []);

  return (
    <AppProviders>
      <AppRouter />
      <Toaster
        position="top-right"
        richColors
        closeButton
        duration={4000}
        toastOptions={{
          classNames: {
            toast: 'font-sans text-sm',
          },
        }}
      />
    </AppProviders>
  );
}
